import React from 'react'
import { styled } from '@mui/material/styles'
import { ImageIcon } from '@/icon'
import { Avatar } from '@mui/material'
import menu_icon_black from '@/asset/img/menu_icon_black.webp'

export const OrgIcon = styled(Avatar)(() => ({
  width: '64px',
  height: '64px',
  fontSize: '32px',
}))

export const Content = styled('div')(() => ({
  padding: '30px',
  display: 'flex',
  flexDirection: 'column',
  gap: '30px',
}))

export const LabelIcon = () => {
  return <ImageIcon src={menu_icon_black} />
}
